import script from "./CampaignsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsTable.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsTable.vue?vue&type=style&index=0&id=603fe85c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-603fe85c"]])

export default __exports__